export enum DealStatus {
	Pending = 'pending',
	Completed = 'checkCircle',
	NotStarted = 'unCheckCircle',
}

export interface DealProgressStates {
	customizeDeal: string;
	testDrive: string;
	getApproval: string;
	protectionsOptions: string;
	accessories: string;
}

export enum DealStepsApi {
	CustomizeDeal = 'CUSTOMIZE_DEAL',
	TestDrive = 'TEST_DRIVE',
	GetApproved = 'GET_APPROVED',
	ProtectionsOptions = 'PROTECTIONS_OR_OPTIONS',
	Accessories = 'ACCESSORIES',
}

export enum DealStatusesApi {
	Pending = 'PENDING',
	Completed = 'COMPLETED',
	NotStarted = 'NOT_STARTED',
}

export interface UpdateDealStateRequest {
	step: DealStepsApi;
	status: DealStatusesApi;
	writeupId: number;
}

export interface TileProperties {
	tileName: string | undefined;
	title: string;
	descriptionTitle: string | undefined;
	descriptionSubTitle: string | undefined;
	redirectTo: string;
	feature: string;
	showStatus: boolean;
}
